import axiosNew from "../../../helpers/axios"


export const postCreateInspirationGallery = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'inspiration-gallery/create-gallery',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}



export const getInspirationGalleryList = async (payload = {}) => {
    let url = `inspiration-gallery/gallery-list`;

    const params = {};

    // pagination
    if (payload.skip !== undefined) params.skip = payload.skip;
    if (payload.limit !== undefined) params.limit = payload.limit;

    // search (ONLY if exists)
    if (payload.search && Object.keys(payload.search).length > 0) {
        params.search = payload.search
    }

    // filter (optional – future proof)
    if (payload.filter && Object.keys(payload.filter).length > 0) {
        params.filter = payload.filter
    }

    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url,
                method: "POST",
                data: params, // axios will auto-create query string
            });

            resolve({ data: res.data ?? {} });
        } catch (error) {
            console.log("🚀 ~ getInspirationGalleryList ~ error:", error);
            resolve({ data: error?.response?.data ?? {} });
        }
    });
};


export const getInspirationGalleryDetails = async (id) => {
    let url = `inspiration-gallery/get-gallery/${id}`;


    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url,
                method: "GET",

            });

            resolve({ data: res.data ?? {} });
        } catch (error) {
            console.log("🚀 ~ getInspirationGalleryList ~ error:", error);
            resolve({ data: error?.response?.data ?? {} });
        }
    });
};

export const getInspirationGalleryImageById = async (payload) => {
    let url = `inspiration-gallery/get-gallery-images/${payload.id}`;
    const params = {};
    if (payload.skip !== undefined) params.skip = payload.skip;
    if (payload.limit !== undefined) params.limit = payload.limit;

    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url,
                data: params,
                method: "POST",

            });

            resolve({ data: res.data ?? {} });
        } catch (error) {

            resolve({ data: error?.response?.data ?? {} });
        }
    });
};
//Upload file t
export const getAttachmentPreUrl = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'aws/upload-file',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const uploadAttachmentToAWS = async (file, url) => {
    try {
        const formData = new FormData()
        formData.append('file', file) // Assuming the file is passed as 'file'
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type,
            },
            body: file?.originFileObj ? file.originFileObj : file, // Directly sending the file as the body of the request
        })

        if (!response.ok) {
            throw new Error(`Failed to upload file: ${response.statusText}`)
        }
        return response
    } catch (error) {
        console.log('🚀 ~ uploadResumeS3Url ~ error:', error)
    }
}